import React, { useState, useEffect } from 'react';
import { usePopup } from '../../context/PopupContext';

const PaymentOptions = ({ selectedAddress, onSelect, cartItems, couponCode }) => {
  const { showPopup } = usePopup();
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [loading, setLoading] = useState(false);

  // Secure Coupon Validation Function
  const validateCouponSecurely = async (paymentMethod = 'Cash on Delivery') => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/payment/validate-offer`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_SECRET_KEY,
         },
        body: JSON.stringify({ cartItems, couponCode, paymentMethod }),
      });
      const data = await res.json();
      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  // Auto-fetch Delivery Fee for COD on load & when cart/coupon changes
  useEffect(() => {
    const fetchDeliveryFee = async () => {
      try {
        const response = await validateCouponSecurely();
        if (response && response.success) {
          setDeliveryFee(response.deliveryFee || 0);
        } else {
          setDeliveryFee(0);
          showPopup(response?.message || 'Failed to fetch delivery fee');
        }
      } catch (err) {
        console.error(err);
        setDeliveryFee(0);
        showPopup('Network error while fetching delivery fee');
      }
    };

    fetchDeliveryFee();
  }, [cartItems, couponCode]);

  // Handle Payment Selection
  // Handle Payment Selection
const handleSelectPayment = async (method) => {
  setLoading(true);
  const response = await validateCouponSecurely(method);
  setLoading(false);
  if (!response || !response.success) {
    showPopup(response?.message || 'Coupon validation failed');
    return;
  }

  setDeliveryFee(response.deliveryFee || 0);

  // ✅ GA4 Event Tracking
  if (window.gtag) {
    window.gtag('event', 'begin_checkout', {
      currency: 'INR',
      payment_method: method,
      value: response.finalTotal,
      items: cartItems.map((item) => ({
        item_id: item.id,
        item_name: item.title,
        quantity: item.quantity,
        price: item.price,
      })),
    });
  }

  onSelect(method, response.finalTotal);
};


  return (
    <div className="mt-6">
      <h3 className="text-gray-700 font-semibold mb-3">Choose Payment Method</h3>
      <div className="grid grid-cols-2 gap-4">
        {/* COD Option */}
        <button
          onClick={() => handleSelectPayment('Cash on Delivery')}
          className="border rounded-lg p-4 text-center hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-purple-500"
          disabled={loading}
        >
          <p className="font-medium text-gray-800">Cash on Delivery</p>
          <p className="text-xs text-gray-600 mt-1">
            {deliveryFee > 0 ? `Delivery Fee: ₹${deliveryFee}` : 'Free Delivery'}
          </p>
        </button>

        {/* Pay Online Option */}
        <button
          onClick={() => handleSelectPayment('Pay Online')}
          className="border rounded-lg p-4 text-center hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-purple-500"
          disabled={loading}
        >
          <p className="font-medium text-gray-800">Pay Online</p>
          <p className="text-xs text-purple-700 mt-1">
            Extra 5% OFF Applied
          </p>
        </button>
      </div>

      {/* Show Delivery Fee Info */}
      {deliveryFee > 0 && (
        <div className="mt-4 text-sm text-red-600">
         ₹{deliveryFee} delivery fee for orders below ₹500
        </div>
      )}
    </div>
  );
};

export default PaymentOptions;
